import axios from 'axios';
import * as actionTypes from './types';
import { socket } from '../socket';


export const retrieveBusinessChallenge = (journeyId) => {
  return (dispatch) => {
    axios
      .get('/api/business-challenge/journey_id/' + journeyId)
      .then((res) => {
        console.log('BC Result: ', res);
        if (res.data.business_challenge !== null) {
          dispatch(addBusinessChallengeId(res.data.business_challenge.id));
          dispatch(addCompanyGoal(res.data.business_challenge.company_goal));
          dispatch(addMeasureOne(res.data.business_challenge.method_one));
          dispatch(addMeasureTwo(res.data.business_challenge.method_two));
          dispatch(addMeasureThree(res.data.business_challenge.method_three));
          dispatch(
            assembleFullChallenge(res.data.business_challenge.full_challenge)
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const updateBusinessChallenge = (
  businessChallengeId,
  journeyId,
  fullChallenge,
  companyGoal,
  measureOne,
  measureTwo,
  measureThree
) => {
  if (businessChallengeId) {
    return async (dispatch) => {
      try {
        const res = await axios.put(
          '/api/business-challenge/id/' + businessChallengeId,
          {
            journey_id: journeyId,
            full_challenge: fullChallenge,
            company_goal: companyGoal,
            method_one: measureOne,
            method_two: measureTwo,
            method_three: measureThree,
          }
        );
        console.log(res);
        dispatch(addBusinessChallengeId(res.data.saved.id));
      } catch (error) {
        console.log(error);
      }
    };
  } else {
    return async (dispatch) => {
      try {
        const res = await axios.post('/api/business-challenge', {
          journey_id: journeyId,
          full_challenge: fullChallenge,
          company_goal: companyGoal,
          method_one: measureOne,
          method_two: measureTwo,
          method_three: measureThree,
        });
        console.log(res);
        dispatch(addBusinessChallengeId(res.data.saved.id));
      } catch (error) {
        console.log(error);
      }
    };
  }
};

export const deleteJourneyBusinessChallenge = (journey_id) => {
  return (dispatch) => {
    axios
      .delete('/api/business-challenge/journey_id/' + journey_id)
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const setBusinessChallenge = (challenge) => (dispatch) => {
  dispatch(addBusinessChallengeId(challenge.id));
  dispatch(addCompanyGoal(challenge.company_goal));
  dispatch(addMeasureOne(challenge.method_one));
  dispatch(addMeasureTwo(challenge.method_two));
  dispatch(addMeasureThree(challenge.method_three));
  dispatch(assembleFullChallenge(challenge.full_challenge));
};


 export const addBusinessChallengeDBOnly = (journeyId, businessChallengeId, companyGoal, methodOne, methodTwo, methodThree, fullChallenge) => {
  return () => {
    socket.emit('onBusinessChallengeAddServer', { 
      journey_id: journeyId,
      business_challenge_id: businessChallengeId,
      company_goal: companyGoal,
      method_one: methodOne, 
      method_two : methodTwo, 
      method_three : methodThree,
      full_challenge: fullChallenge
    });
  };
};

export const addBusinessChallengeId = (id) => ({
  type: actionTypes.ADD_BUSINESS_CHALLENGE_ID,
  id: id,
});

export const addCompanyGoal = (companyGoal) => ({
  type: actionTypes.ADD_COMPANY_GOAL,
  companyGoal: companyGoal,
});

export const addMeasureOne = (measureOne) => ({
  type: actionTypes.ADD_MEASURE_ONE,
  measureOne: measureOne,
});

export const addMeasureTwo = (measureTwo) => ({
  type: actionTypes.ADD_MEASURE_TWO,
  measureTwo: measureTwo,
});

export const addMeasureThree = (measureThree) => ({
  type: actionTypes.ADD_MEASURE_THREE,
  measureThree: measureThree,
});

export const assembleFullChallenge = (fullChallenge) => ({
  type: actionTypes.ASSEMBLE_FULL_CHALLENGE,
  fullChallenge: fullChallenge,
});
